import { Component, Injector } from '@angular/core';

import { BaseLayoutComponent } from '../shared/base-layout.component';

import { navItems } from './_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './eigreja-layout.component.html',
})
export class EIgrejaLayoutComponent extends BaseLayoutComponent {

  constructor(
    protected injector: Injector
  ) {
    super(injector, navItems);
  }
}
